// extracted by mini-css-extract-plugin
export default {"formWidth":"_d454e4de"};